import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  HostListener,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { Subscription } from 'rxjs';

import { SortService } from './sortable-column.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: '[sortable-column]',
  templateUrl: './sortable-column.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./sortable-column.component.scss'],
  standalone: false,
})
export class SortableColumnComponent implements OnInit, OnDestroy {
  constructor(private sortService: SortService) {}

  @Input('sortable-column') columnName: string;

  @Input('sort-direction') sortDirection = '';
  private sortDirectionOld = null;

  private columnSortedSubscription: Subscription;

  @HostListener('click')
  sort() {
    console.log(this.sortDirection, this.columnName);
    if (this.sortDirectionOld === null || this.sortDirectionOld === 'asc') {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      this.sortDirectionOld = this.sortDirection;
    } else if (this.sortDirectionOld === 'desc' && this.sortDirection === 'desc') {
      this.sortDirection = null;
      this.sortDirectionOld = null;
    }

    this.sortService.columnSorted({
      sortColumn: this.sortDirection ? this.columnName : null,
      sortDirection: this.sortDirection,
    });
  }

  ngOnInit() {
    this.columnSortedSubscription = this.sortService.columnSorted$.subscribe((event) => {
      if (this.columnName !== event.sortColumn) {
        this.sortDirection = null;
        this.sortDirectionOld = null;
      }
    });
  }

  ngOnDestroy() {
    if (!this.columnSortedSubscription) {
      return;
    }
    this.columnSortedSubscription.unsubscribe();
  }
}
